import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";

import images from "../../constants/images";
import "./Navbar.css";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  const [subMenuOpen, setSubMenuOpen] = React.useState(false);

  const closeAllMenu = () => {
    setToggleMenu(false);
    setSubMenuOpen(false);
  };
  const toggleSubMenu = (e) => {
    e.preventDefault();
    setSubMenuOpen(!subMenuOpen);
  };

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.phohalong} alt="app__logo" />
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans">
          <a href="#home">Home</a>
        </li>
        <li className="p__opensans app__navbar-menu-dropdown-item">
          <a href="#menu">Menu</a>
          <ul className="app__navbar-dropdown">
            <li className="p__opensans">
              <a href="#pho">Pho</a>
            </li>
            <li className="p__opensans">
              <a href="#appetizer">Appetizer</a>
            </li>
            <li className="p__opensans">
              <a href="#vermicelli">Vermicelli or Rice</a>
            </li>
            <li className="p__opensans">
              <a href="#lomein">Lomein</a>
            </li>
            <li className="p__opensans">
              <a href="#rice_and_noodle">Rice & Noodle</a>
            </li>
            <li className="p__opensans">
              <a href="#kids">Kids Meal</a>
            </li>
            <li className="p__opensans">
              <a href="#beverages">Beverages</a>
            </li>
          </ul>
        </li>
        <li className="p__opensans">
          <a href="#contact">Order Pickup</a>
        </li>
      </ul>
      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu(true)}
        />

        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <MdOutlineRestaurantMenu
              fontSize={27}
              className="overlay__close"
              onClick={() => setToggleMenu(false)}
            />
            <ul className="app__navbar-smallscreen_links">
              <li className="p__opensans">
                <a href="#home" onClick={closeAllMenu}>
                  Home
                </a>
              </li>
              <li className="p__opensans">
                <a
                  href="#menu"
                  onClick={toggleSubMenu}
                  aria-expanded={subMenuOpen}
                  aria-controls={"smallscreen-submenu"}
                >
                  Menu
                </a>
                {subMenuOpen && (
                  <ul className="app__navbar-smallscreen-submenu">
                    <li className="p__opensans">
                      <a href="#pho" onClick={closeAllMenu}>
                        Pho
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#appetizer" onClick={closeAllMenu}>
                        Appetizer
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#vermicelli" onClick={closeAllMenu}>
                        Vermicelli or Rice
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#lomein" onClick={closeAllMenu}>
                        Lomein
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#rice_and_noodle" onClick={closeAllMenu}>
                        Rice & Noodle
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#kids" onClick={closeAllMenu}>
                        Kids Meal
                      </a>
                    </li>
                    <li className="p__opensans">
                      <a href="#beverages" onClick={closeAllMenu}>
                        Beverages
                      </a>
                    </li>
                  </ul>
                )}
              </li>
              <li className="p__opensans">
                <a href="#contact" onClick={closeAllMenu}>
                  Order Pickup
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
